import React from 'react';

import { SortDirection } from '../types';
import { elements } from '@ecosystem/newron-design-system';

export interface ArrowProps {
  isVisible: boolean;
  sortDirection: SortDirection.asc | SortDirection.desc;
  colour?: string;
  size?: number;
}

const Arrow: React.FC<ArrowProps> = ({ isVisible, sortDirection, colour = 'text-heading', size = 24 }) => {
  if (!isVisible) {
    return null;
  }

  const { Icon } = elements;

  return (
    <div data-test-id="sortArrow" className="SortArrow">
      <Icon>{sortDirection === SortDirection.asc ? <Icon.icons.ArrowUpward /> : <Icon.icons.ArrowDownward />}</Icon>
    </div>
  );
};

export default Arrow;
